import React from "react";
import UploadEngine from "./uploadEngine";

export default class UploadButton extends React.Component {
  handleUpload = () => {
    const { recordedBlob, chapterTitle, chapterId, projectId, onUploadComplete, onUploadProgress, onUploadError, onUploadStart } = this.props;
    
    try {
      if (!recordedBlob) return;
      
      // Notify parent that upload is starting
      if (typeof onUploadStart === 'function') {
        onUploadStart();
      }
      
      const fileNameBase = (chapterTitle || 'live-read')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
      
      const extension = recordedBlob.fileExtension || 'webm';
      const mimeType = recordedBlob.type || (extension === 'mp4' ? 'video/mp4' : 'video/webm');
      const file = new File([recordedBlob], `${fileNameBase}.${extension}`, { type: mimeType });
      const token = (localStorage.getItem('token') || '').replace(/^Bearer\s+/i, '');

      if (typeof onUploadProgress === 'function') {
        onUploadProgress(0);
      }

      const engine = new UploadEngine({
        file,
        token,
        onProgress: (pct) => {
          if (typeof onUploadProgress === 'function') {
            onUploadProgress(Math.max(0, Math.min(100, Math.round(pct))));
          }
        },
        onComplete: (data) => {
          if (typeof onUploadComplete === 'function') {
            onUploadComplete(data);
          }
        },
        onError: (err) => {
          if (typeof onUploadError === 'function') {
            onUploadError(err);
          }
        },
        completeExtra: {
          contentType: file.type,
          sizeBytes: file.size,
          chapterId,
          projectId,
        },
      });
      
      engine.start();
    } catch (err) {
      if (typeof onUploadError === 'function') {
        onUploadError(err);
      }
    }
  };

  render() {
    const { uploading = false, uploadPct = 0, className = "", style } = this.props;
    
    return (
      <button 
        disabled={uploading} 
        className={`lrp-btn lrp-btn-primary ${className}`.trim()} 
        style={style} 
        onClick={this.handleUpload}
        title={uploading ? `Uploading ${uploadPct}%` : "Upload recorded video"}
      >
        {uploading ? 'Uploading…' : 'Upload'}
      </button>
    );
  }
}
